<template>
  <div class="emendas-por-area">
    <div class="row">
      <PublicHeader :title="'Emendas Por Secretaria'">
        <div class="col-xs-12 col-sm-6">
          <p>
            Aqui você encontra as secretarias que receberam emendas
            parlamentares da Câmara Municipal de Santos, seus valores totais e a
            quantidade de emendas recebidas.
          </p>
          <p>
            No ano de <SelectAnoEmendas />,
            <ValorDestaqueHeader
              :value="secretariasComEmendas.length"
              :isLoading="loading"
            />
            secretarias receberam emendas parlamentares de
            <ValorDestaqueHeader
              :value="vereadoresComEmendas.length"
              :isLoading="loading"
            />
            vereadores, totalizando
            <ValorDestaqueHeader
              :value="formatarMoeda(valorTotalEmendas)"
              :isLoading="loading"
            />
            em emendas. Veja abaixo mais informações sobre as secretarias.
          </p>
        </div>
      </PublicHeader>
    </div>
    <div class="container">
      <Breadcrumb :links="breadcrumb"></Breadcrumb>
      <div class="row form-group">
        <div class="col-xs-12">
          <h3>Total recebido em emendas por secretaria</h3>
        </div>
      </div>
      <div class="row">
        <div
          v-for="item in listaCards"
          :key="item.nome"
          class="col-xs-12 col-sm-6 col-md-4 card-base"
        >
          <CardEmendas :item="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  PublicHeader,
  Breadcrumb,
  CardEmendas,
  SelectAnoEmendas,
  ValorDestaqueHeader
} from '../../../components'
import { formatarMoeda } from '@/utils'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    PublicHeader,
    Breadcrumb,
    CardEmendas,
    SelectAnoEmendas,
    ValorDestaqueHeader
  },
  data() {
    return {
      breadcrumb: [
        {
          label: 'Emendas Parlamentares',
          named_link: { name: 'emendas_parlamentares' }
        },
        {
          label: 'Emendas Por Secretaria'
        }
      ]
    }
  },
  methods: {
    formatarMoeda
  },
  computed: {
    ...mapState({
      emendas: state => state.emendas_parlamentares.emendas,
      loading: state => state.emendas_parlamentares.loading
    }),
    ...mapGetters([
      'valorTotalEmendas',
      'valorTotalPorSecretaria',
      'secretariasComEmendas',
      'vereadoresComEmendas'
    ]),
    listaCards() {
      const items = []
      this.secretariasComEmendas.forEach(secretaria => {
        items.push({
          nome: secretaria,
          namedRoute: {
            name: 'emendas_detalhe_por_area',
            params: { secretaria }
          },
          valor: this.valorTotalPorSecretaria(secretaria)
        })
      })
      return items
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/public/emendas_parlamentares/EmendasPorArea.vue